import { BranchCashAction } from '@pages/Authorized/Branch/CashPage'

import PageTitle, { PageTitleAction } from '@components/molecules/PageTitle'

type Props = {
  onAction: (type: BranchCashAction) => void
}

export default function BranchCashTitle({ onAction }: Props): JSX.Element {
  const actions: PageTitleAction[] = [
    { label: '내보내기', buttonType: 'dashed', onClick: () => onAction('export') },
    { label: '현금 추가', buttonType: 'primary', onClick: () => onAction('add') },
  ]

  return <PageTitle title="현금" actions={actions} />
}
